module.exports = function() {
  return new Worker(__webpack_public_path__ + "1740823d67159e72a0de.worker.js");
};